import { createFeatureFlagPlugin } from '@loadsmart/vue-feature-flags';
import config from '@/config/config';
import { localStorageKeys } from '@/enums/local_storage';

function getAuthHeader() {
  const token = localStorage.getItem(localStorageKeys.ACCESS_TOKEN);
  return `Bearer ${token ?? ''}`;
}

function getUnleashUrl() {
  const unleashUrl = config.unleash_url?.trim();
  if (unleashUrl) {
    return unleashUrl;
  }

  return new URL('/feature-flag/proxy', config.neutron_url).toString();
}

function getUnleashClientKey() {
  const clientKey = config.unleash_client_key?.trim();
  if (clientKey) {
    return clientKey;
  }

  return getAuthHeader();
}

export default createFeatureFlagPlugin({
  config: {
    url: getUnleashUrl(),
    appName: config.unleash_app_name?.trim() || 'opendock-nova',
    clientKey: getUnleashClientKey(),
    environment: config.environment === 'production' ? 'production' : 'development'
  }
});
